export const MM_PER_INCH = 25.4

export const MM_PER_METRE = 1000

export const METRES_PER_FOOT = 0.3048

export const LITRES_PER_GALLON = 3.78541
